import { callApiWithAuthorization } from '../CallApi';

export async function getEntityRelations(projectId) {
    const request = await callApiWithAuthorization(
        `/api/v0/project/${projectId}/entityRelations`
    );
    const response = await request.json();
    return response;
}

export async function updateEntityRelation(entityRelationId, properties) {
    const request = await callApiWithAuthorization(
        `/api/v0/entityRelations/${entityRelationId}`,
        {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(properties)
        }
    );
    const response = await request.json();
    return response;
}

export async function deleteEntityRelation(entityRelationId) {
    const request = await callApiWithAuthorization(
        `/api/v0/entityRelations/${entityRelationId}`,
        {
            method: 'DELETE'
        }
    );
    const response = await request.json();
    return response;
}

export async function deleteEntityRelationReferenceAttribute(entityRelationId) {
    const request = await callApiWithAuthorization(
        `/api/v0/entityRelations/${entityRelationId}/referenceAttribute`,
        {
            method: 'DELETE'
        }
    );
    const response = await request.json();
    return response;
}

export async function deleteEntityRelationMirrorAttribute(entityRelationId) {
    const request = await callApiWithAuthorization(
        `/api/v0/entityRelations/${entityRelationId}/mirrorAttribute`,
        {
            method: 'DELETE'
        }
    );
    const response = await request.json();
    return response;
}

export async function createEntityRelation(projectId, organizationId, properties) {
    const request = await callApiWithAuthorization(
        `/api/v0/project/${projectId}/entityRelations`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                organizationId,
                ...properties
            })
        }
    );
    const response = await request.json();
    return response;
}

export async function createReferenceAttribute({
    organizationId,
    projectId,
    entityRelationId,
    parentEntityId,
    referencedEntityId,
    referencedAttributeId,
    attributeProperties
}) {
    const request = await callApiWithAuthorization(
        `/api/v0/entityRelations/${entityRelationId}/referenceAttribute`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                parentEntityId,
                projectId,
                organizationId,
                referencedAttributeId,
                referencedEntityId,
                attributeProperties
            })
        }
    );
    const response = await request.json();
    return response;
}

export async function findFormulaReferencesForUnlink({
    oneEntityId,
    oneEntityName,
    oneEntitySysName,
    manyEntityId,
    manyEntityName,
}) {
    const request = await callApiWithAuthorization(
        `/api/v0/entity/${oneEntityId}/unlink-check/${manyEntityId}/formula-references`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                oneEntityName,
                oneEntitySysName,
                manyEntityName
            })
        }
    );
    const response = await request.json();
    return response;
}